import { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import NavbarTopAdmin from './components/navbarTopAdmin'
import NavbarBottomAdmin from './components/navbarBottomAdmin'
import AuthProvider from '../Authentication/authProvider'

function CheckFoodTruck() {
    const [foodTrucks, setFoodTrucks] = useState([])
    const [foodTrucksImmutabile, setFoodTrucksImmutabile] = useState([])
    const [dati, setDati] = useState({})
    const [img, setImg] = useState({ img: [], video: null })
    const [tipoCucina, setTipoCucina] = useState([])
    const [titolo, setTitolo] = useState('Tutti i FoodTruck')
    const [dimensione, setDimensione] = useState(null)

    const divDettagli = useRef()
    const confirmElimina = useRef()
    const details = {
        display: 'grid', gridTemplateColumns: '0.4fr 1fr', gap: '5px'
    }

    const getFoodTrucks = () => {
        axios.post('/getArtisti/ASC/nome').then(res => {
            const rty = res.data.filter(item => item.sezione === 'truck')
            setFoodTrucks(rty)
            setFoodTrucksImmutabile(rty)
        }).catch((err) => { console.error(err) })
    }

    const dettagli = async (e) => {
        setDati(e)
        setImg({ img: e.img.split(','), video: e.video })
        setTipoCucina(e.genere.split(','))
        if (e.video) {
            axios.get(`/video-size/${e.video}`).then(res => { setDimensione(res.data.sizeMB) })
        }
        divDettagli.current.style.top = '0'
    }
    const approva = (stato) => {
        try {
            axios.post(`/approvaArtista/${dati.id}/${dati.emailUser}/${stato}/${dati.idUser}`).then(res => {
                divDettagli.current.style.width = '0px'
                divDettagli.current.style.left = '-20%'
                document.body.style.overflow = "scroll"
                if (stato === 'delete') {
                    if (dati.img) axios.delete(`/delete-img/${dati.img}`)

                    if (dati.video) axios.delete(`/delete-video/${dati.video}`)
                }
                setTimeout(() => { window.location.reload() }, 2000)
            })
        } catch (err) { console.log(err) }
    }

    useEffect(() => { getFoodTrucks() }, [])
    // useEffect(() => { console.log('dati:', dati) }, [dati])
    return (<>
        <AuthProvider />
        <NavbarTopAdmin />
        <NavbarBottomAdmin />
        {/* <AuthProvider /> */}
        <div style={{ margin: '8rem 0 10rem 0' }}>
            <div className='mt-4' style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '5px', marginLeft: '1em' }}>
                <div>
                    <button onClick={() => {
                        setFoodTrucks(foodTrucksImmutabile.filter(item => item.accettazione === 'false'))
                        setTitolo('FoodTruck da approvare')
                    }} className='btn btn-warning'>NoAccep
                    </button>
                </div>
                <div>
                    <button onClick={() => {
                        setFoodTrucks(foodTrucksImmutabile.filter(item => item.accettazione === 'rejection'))
                        setTitolo('FoodTruck rifiutati')
                    }} className='btn btn-danger'>Reject
                    </button>
                </div>
                <div>
                    <button onClick={() => {
                        setFoodTrucks(foodTrucksImmutabile.filter(item => item.accettazione === 'true'))
                        setTitolo('FoodTruck approvati')
                    }} className='btn btn-success'>Accept
                    </button>
                </div>
                <div>
                    <button onClick={() => {
                        setFoodTrucks(foodTrucksImmutabile)
                        setTitolo('Tutti i FoodTruck')
                    }} className='btn btn-primary'>Tutti
                    </button>
                </div>
            </div><hr />
            <p className='fs-4 text-center mt-5' style={{ color: 'navy' }}><b>{titolo}</b></p>
            {foodTrucks &&
                <div style={{ position: 'relative' }}>
                    <table className="table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Nome</th>
                                <th>Specialità</th>
                                <th className='thDesk'>Genere</th>
                                <th>Video</th>
                                <th className='thDesk'>Città</th>
                                <th className='thDesk'>Email</th>
                            </tr>
                        </thead>
                        <tbody>
                            {foodTrucks.map(foodTruck => {
                                let flag
                                switch (foodTruck.accettazione) {
                                    case 'true': flag = 'lawngreen'; break
                                    case 'false': flag = 'orange'; break
                                    case 'rejection': flag = 'red'; break
                                    default: flag = 'transparent'
                                }
                                return (
                                    <tr onClick={() => { dettagli(foodTruck) }} key={foodTruck.id} style={{ cursor: 'pointer' }}>
                                        <td><div style={{
                                            borderRadius: '50px',
                                            width: '7px',
                                            height: '7px',
                                            marginTop: '12px',
                                            backgroundColor: flag
                                        }}></div>
                                        </td>
                                        <td>{foodTruck.nome}</td>
                                        <td>{foodTruck.cognome}</td>
                                        <td className='thDesk'>{foodTruck.genere}</td>
                                        <td>{foodTruck.video ? <span>Vid</span> : null}</td>
                                        <td className='thDesk'>{foodTruck.città}</td>
                                        <td className='thDesk'>{foodTruck.emailUser}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    {!foodTrucks && <h3 className='m-3'>Nessun FoodTruck da mostrare</h3>}

                    {/* ---------- BANEER DETTAGLI ---------- */}
                    <div className='visualDettagli' ref={divDettagli}>
                        {dati.id &&
                            <div style={{ marginBottom: '6rem' }}>
                                <span style={{ fontSize: '2rem', float: 'right', cursor: 'pointer' }} onClick={() => {
                                    divDettagli.current.style.top = '120%'
                                }}>X
                                </span><br />
                                <h4>
                                    {dati.accettazione === 'true' && <span style={{ color: 'mediumseagreen' }}>FoodTruck in-line</span>}
                                    {dati.accettazione === 'false' && <span style={{ color: 'orangered' }}>FoodTruck da approvare</span>}
                                    {dati.accettazione === 'rejection' && <span style={{ color: 'red' }}>FoodTruck rifiutato</span>}
                                </h4> <hr />
                                {dati.img &&
                                    <div className='mt-1'>
                                        <p>IMMAGINI CARICATE</p>
                                        {img.img.map((elem, index) => (
                                            <span key={index} style={{ marginLeft: '10px' }}>
                                                <img src={`https://leuro-bucket.s3.amazonaws.com/${elem}`} width={150} height={150} />
                                            </span>
                                        ))}

                                    </div>
                                }
                                <div style={{ border: '1px solid lightgray', borderRadius: '5px', marginTop: '3rem', padding: '5px' }}>
                                    <p>DATI DI LOGIN:</p>
                                    <div style={details}>
                                        <div>User Id:</div><div>{dati.idUser}</div>
                                        <div>Email user:</div><div>{dati.emailUser}</div>
                                    </div>
                                </div>

                                <h5 className='mt-3'>DATI FOODTRUCK:</h5>
                                <div style={details}>
                                    <div>Nome:</div><div>{dati.nome}</div>
                                </div>
                                {dati.genere &&
                                    <div style={details}>
                                        <div>Genere:</div>
                                        <div>
                                            {tipoCucina.map((elem, index) => (
                                                <span key={index}>
                                                    {elem}
                                                    {index < tipoCucina.length && <span>, </span>}
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                }
                                <div style={details}>
                                    <div>Regione:</div><div>{dati.regione}</div>
                                    <div>Città:</div><div>{dati.città}</div>
                                </div>

                                <div style={details}>
                                    <div>Email:</div><div>{dati.emailUser}</div>
                                </div>
                                {dati.telefono &&
                                    <div style={details}>
                                        <div>Telefono:</div><div>{dati.telefono}</div>
                                    </div>
                                }
                                <div style={details}>
                                    <div>Creato il: </div><div>{dati.created_at}</div>
                                    <div>ID: </div><div>{dati.id}</div>
                                </div>

                                <h5 className='mt-3'>DESCRIZIONE</h5>
                                <textarea value={dati.descrizione} style={{ fontStyle: 'italic', fontSize: '13px' }} rows={8} className='form-control' />

                                {dati.video &&
                                    <div>
                                        <h5>VIDEO</h5>
                                        <video src={`https://leuro-bucket.s3.amazonaws.com/video/${img.video}`} id={'videoPreview'}
                                            style={{ width: '60%', maxHeight: '200px', borderRadius: '5px' }} controls />
                                        <p><b>{dimensione} MB</b> <br />{dati.video}</p>
                                    </div>
                                }

                                <div style={{ border: '1px solid lightgrey', borderRadius: '20px', padding: '15px 5px', marginTop: '2rem' }}>
                                    <h5 style={{ fontFamily: 'sans-serif' }}>LINK</h5>
                                    {dati.url &&
                                        <div className='btn btn-warning'>
                                            <a href={dati.url} style={{ textDecoration: 'none', color: 'navy' }} target='_blank'>Sito web</a>
                                        </div>
                                    }
                                    {dati.fb &&
                                        <span style={{ backgroundColor: 'royalblue', borderRadius: '25px', marginLeft: '1rem', padding: '5px 13px' }}>
                                            <a href={dati.fb} style={{ textDecoration: 'none', color: 'white', fontSize: 'x-large' }} target='_blank'><b>f</b></a>
                                        </span>
                                    }
                                    {dati.youtube &&
                                        <span style={{ backgroundColor: 'red', borderRadius: '25px', marginLeft: '1rem', padding: '5px 13px' }}>
                                            <a href={dati.youtube} style={{ textDecoration: 'none', color: 'white' }} target='_blank'><b>▷</b></a>
                                        </span>
                                    }
                                </div>

                                <div className='mt-5'>
                                    <button className='btn btn-success float-start' onClick={() => { approva(true) }}>
                                        Approva
                                    </button>

                                    <button className='btn btn-dark' style={{ marginLeft: '20%' }}
                                        onClick={() => { confirmElimina.current.style.display = 'block' }}>
                                        Elimina
                                    </button>

                                    <button className='btn btn-danger float-end'
                                        onClick={() => { approva(null) }}>
                                        Rifiuta
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
        <div ref={confirmElimina} style={{
            display: 'none',
            position: 'fixed',
            backgroundColor: 'cornsilk',
            top: '30%',
            left: '0',
            right: '0',
            margin: 'auto',
            width: '70%',
            height: '40%',
            padding: '2rem',
            zIndex: '1',
            borderRadius: '10px'
        }}>
            Eliminare definitivamente {dati.titolo}?
            <div className='mt-5'>
                <button className='float-start btn btn-danger'
                    onClick={() => {
                        confirmElimina.current.style.display = 'none'
                        approva('delete')
                    }}>Elimina</button>
                <button className='float-end btn btn-success'
                    onClick={() => { confirmElimina.current.style.display = 'none' }}>Annulla</button>
            </div>
        </div>
    </>
    )
}
export default CheckFoodTruck